__turbopack_context__.v({
  "alignmentRight": "jk3zZq_alignmentRight",
  "fields": "jk3zZq_fields",
  "form": "jk3zZq_form",
  "narrowField": "jk3zZq_narrowField",
  "personalDetailsFormField": "jk3zZq_personalDetailsFormField",
  "personalDetailsFormFields": "jk3zZq_personalDetailsFormFields",
  "sizeFull": "jk3zZq_sizeFull",
  "sizeL": "jk3zZq_sizeL",
  "sizeM": "jk3zZq_sizeM",
  "sizeS": "jk3zZq_sizeS",
  "sizeXS": "jk3zZq_sizeXS",
  "sizeXXS": "jk3zZq_sizeXXS",
  "submitButton": "jk3zZq_submitButton",
  "toggleGroup": "jk3zZq_toggleGroup",
});
